module.exports = __webpack_public_path__ + "static/media/strava-logo.6062b709.png";